import styled from 'styled-components';
import alertIcon from '../../../images/alert.png';
import alert2xIcon from '../../../images/alert@2x.png';
import pushkinIcon from '../../../images/pushkin.png';
import pushkin2xIcon from '../../../images/pushkin@2x.png';
import { getIconCss } from '../../../helpers/icons';

export default {
  Container: styled.div<{ sideBarPosition?: string }>`
    display: flex;
    justify-content: center;
    position: absolute;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    z-index: 1;

    @media screen and (max-width: 700px) {
      position: absolute;
      display: block;
      right: 16px;
      left: auto;
      max-width: 285px;
      bottom: ${({ theme: { withAnnouncements } }) => {
        if (withAnnouncements) {
          return `180px`;
        }

        return '55px';
      }};
      transform: none;
    }
  `,

  Icon: styled.span`
    flex-shrink: 0;
    margin-right: 16px;
    ${getIconCss(alertIcon, alert2xIcon, 60, 55)};
  `,

  PushkinIcon: styled.span`
    flex-shrink: 0;
    margin-right: 16px;
    ${getIconCss(pushkinIcon, pushkin2xIcon, 65, 64)};
  `,

  Close: styled.button`
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 0;
    padding: 0;
    background: transparent;
    outline: none;
    border: 0;

    svg {
      fill: black;
      opacity: 0.5;
    }

    @media (min-width: 720px) {
      &:hover svg {
        opacity: 0.8;
      }
    }
  `,

  Attention: styled.span`
    display: block;
    color: rgb(255, 0, 0);
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    margin-right: 8px;
  `,

  Item: styled.div`
    position: relative;
    max-width: 292px;
    display: flex;
    padding: 16px;
    padding-right: 20px;
    border-radius: 9px;
    margin: 0 8px;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    box-sizing: border-box;

    &:last-child {
      /* margin-left: 30px; */
    }

    @media screen and (max-width: 700px) {
      margin: 15px 0;

      &:last-child {
        margin-left: 0;
      }
    }
  `,
};
